module.exports = __webpack_public_path__ + "img/cy.4cc56e1f.png";